import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ThemePalette } from '@angular/material/core';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatButton } from '@angular/material/button';

import { TranslateModule } from '@ngx-translate/core';
import { MarkdownPipe } from '@shared/pipes/markdown.pipe';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText: string | undefined;
  altConfirmText?: string;
  cancelText?: string;
  confirmColor?: ThemePalette;
}

@Component({
  selector: 'recrewt-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    FlexModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    TranslateModule,
    MarkdownPipe,
  ],
})
export class ConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

  constructor() {
    const dialogRef = this.dialogRef;

    dialogRef.disableClose = true;
  }

  noActionClicked(): void {
    this.dialogRef.close(null);
  }
}
